/*****************************************************************/
/* There are no AWS credentials here. They are only the id’s for the resources
   involved. And these resources cannot be accessed without authentication.
*/

export default {
    MAX_ATTACHMENT_SIZE: 10000000, // 10mb
    s3: {
        REGION: "",
        BUCKET: ""
    },
};



// WEBPACK FOOTER //
// ./src/config.js